import { render, staticRenderFns } from "./yzVideoUpload.vue?vue&type=template&id=b319f8b6&scoped=true&"
import script from "./yzVideoUpload.vue?vue&type=script&lang=js&"
export * from "./yzVideoUpload.vue?vue&type=script&lang=js&"
import style0 from "./yzVideoUpload.vue?vue&type=style&index=0&id=b319f8b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b319f8b6",
  null
  
)

export default component.exports